/*
 * @Description: '首页'所有的路由
 * @Date: 2019-07-22 16:47:39
 * @LastEditTime: 2019-07-25 10:11:20
 * @LastEditors: Please set LastEditors
*/
import { i18n } from '@/locales/index';
export default [
    {
        path: '/',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home',
        meta: {
            nav: i18n.t("header.page")
        }
    },
    {
        path: '/home',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home-2',
        meta: {
            nav: i18n.t("header.page")
        }
    },
    {
        path: '/innovation',
        component: resolve => require(['@/views/home/innovation'], resolve),
        name: 'Innovation',
        meta: {
            nav: i18n.t("home.innovation"),
        }
    },
    {
        path: '/os',
        component: resolve => require(['@/views/osPromotion'], resolve),
        name: 'OS',
        meta: {
            nav: "OS"
        }
    },
    {
        path: '/aleo-activity',
        component: resolve => require(['@/views/home/aleoActivity'], resolve),
        name: 'aleoActivity',
        meta: {
            nav: "aleoActivity"
        },
    },
    {
        path: '/help-center',
        component: resolve => require(['@/views/helpCenter'], resolve),
        name: 'helpCenter',
        meta: {
            nav: i18n.t("footer.help")
        }
    },
    {
        path: '/help-doc-details/:id',
        component: resolve => require(['@/views/helpCenter/components/details'], resolve),
        name: 'notice-detail',
        meta: {
            nav: '帮助文档详情'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/home.js